// extracted by mini-css-extract-plugin
export default {"title":"y_-z","warning":"z_-z","sizeOptionsLegendText":"A_-z"};